export function capitalizeAndReplaceUnderscores(str: string): string {
  if (!str) return "";
  const withSpaces = str.replace(/_/g, " ");
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

export const capitalizeFirstLetter = (str: string) => {
  if (str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};
